/// Girişten sonra gidilecek `returnUrl`'i süzer: yalnız AYNI KAYNAKLI göreli yol kabul edilir.
/// `startsWith('/')` yetmez: `//evil.com`, `/\evil.com` ya da sekmeli `/\t/evil.com` tarayıcıda
/// başka bir kaynağa gider (açık yönlendirme). URL ayrıştırılır, kaynak karşılaştırılır.
/// Geçerliyse `yol + sorgu + parça` döner (kaynak eklenmez), değilse `null`.
export function safeReturnUrl(raw: string | null | undefined, origin: string): string | null {
  if (!raw || !raw.startsWith('/')) return null;
  let url: URL;
  try {
    url = new URL(raw, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  return url.pathname + url.search + url.hash;
}
